<script>
  import { fade, fly } from "svelte/transition";
  import { onMount } from "svelte";

  let innerWidth = $state(0); // windowsYから名称変更（任意）
  let isFooterVisible = $state(false); // フッターが見えているかどうかの状態

  const breakPoint = 1150;

  const SNS = [
    { link: 'https://x.com/minnano_ginko', icon: "/assets_default/icons/sns/logo_x.svg", alt: "Xロゴアイコン" },
    { link: 'https://www.facebook.com/minnanoginko', icon: "/assets_default/icons/sns/logo_facebook.svg", alt: "facebookロゴアイコン" },
    { link: 'https://www.instagram.com/minnano_ginko_official', icon: "/assets_default/icons/sns/logo_instagram.svg", alt: "instagramロゴアイコン" },
    { link: 'https://www.youtube.com/@minnano_ginko', icon: "/assets_default/icons/sns/logo_youtube.svg", alt: "youtubeロゴアイコン" },
    { link: 'https://note.minna-no-ginko.com/', icon: "/assets_default/icons/sns/logo_note.svg", alt: "noteロゴアイコン" }
  ];

  // フッターを監視するロジック
  $effect(() => {
    // フッターの要素を取得（プロジェクトのHTML構造に合わせてセレクタを調整してください）
    const footer = document.querySelector('footer');

    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // 交差している（見えている）場合は true
        isFooterVisible = entry.isIntersecting;
      },
      {
        rootMargin: '0px',
        threshold: 0.4 // 10%見えたら反応
      }
    );

    observer.observe(footer);

    // クリーンアップ
    return () => observer.disconnect();
  });
</script>

<svelte:window bind:innerWidth={innerWidth} />

<!-- 条件に !isFooterVisible を追加 -->
{#if innerWidth > breakPoint && !isFooterVisible}
  <div
    class="left-area"
    in:fly={{y:20, delay:400, duration:1200}}
    out:fly={{duration: 300,delay:0}}
  >
    <div class="left-content">
      <p class="heading-image">
        <img src="/assets_default/images/common/large/pc_comment_01.webp" alt="">
      </p>

      <ul class="sns-list spacing:bottom:32">
        {#each SNS as sns}
          <li>
            <a href={sns.link} target="_blank" rel="noopener noreferrer">
              <img src={sns.icon} alt={sns.alt} >
            </a>
          </li>
        {/each}
      </ul>

      <ul class="banner-list">
        <li class="spacing:bottom:12">
          <a href="/special/moneysaver/" class="pc-banner-layout" id="common-pc-fixed-banner">
            <img src="/assets_default/images/common/large/pc_banner_01.webp" alt="money saver">
          </a>
        </li>
        <li>
          <a href="/guide/" class="pc-banner-layout" id="common-pc-fixed-banner">
            <img src="/assets_default/images/common/large/pc_banner_02.webp" alt="money saver">
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div
    class="right-area"
    in:fly={{y:20, delay:400, duration:1200}}
    out:fly={{duration: 300,delay:0}}
  >
    <div class="right-content">
      <p class="heading-image spacing:bottom:8">
        <img src="/assets_default/images/common/large/pc_comment_02.webp" alt="">
      </p>
      <span class="move-face spacing:bottom:8">
        <img src="/assets_default/images/common/large/pc_illust.webp" alt="">
      </span>

      <div class="app-download-item">
        <span class="app-download-icon">
          <img src="/assets_default/images/common/large/pc_qr.webp" alt="QRコード">
        </span>
        <p class="owd-text:01"><strong>まずはアプリをダウンロード<br>口座開設から始めよう</strong></p>
      </div>
    </div>
  </div>
{/if}

<style lang="scss">

  .left-area {
    position: fixed;
    top:0;
    left: 0;
    width: calc(50% - 252px);
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .right-area {
    position: fixed;
    top:0;
    right: 0;
    width: calc(50% - 252px);
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 241px;

    .sns-list {
      display: grid;
      gap: 16px;
      grid-template-columns: repeat(5,auto);
      a {
        transition: .2s linear opacity;
        @media (hover: hover) {
          &:hover {
            opacity: .7;
          }
        }
      }
    }

    .heading-image {
      padding: 0 40px;
      img {
        vertical-align: top;
      }
    }

    img {
      max-width: 100%;
    }
  }

  .right-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 290px;
    .heading-image {
      padding: 0 45px;
    }

    .move-face {
      animation: occasional-shake 5s infinite;
      padding: 0 40px;
    }

    .app-download-item {
      display: grid;
      grid-template-columns: 60px 1fr;
      gap: 8px;
      align-items: center;
    }
  }


  .banner-list {
    a {
      transition: .2s linear opacity;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      display: block;
      @media (hover: hover) {
        &:hover {
          opacity: .7;
        }
      }
      img {
        vertical-align: top;
      }
    }
  }

  @keyframes occasional-shake {
    0% { transform: translate(0, 0) rotate(0deg); }
    1% { transform: translate(-2px, -1px) rotate(-1deg); }
    2% { transform: translate(-1px, 2px) rotate(1deg); }
    3% { transform: translate(2px, 1px) rotate(0deg); }
    4% { transform: translate(1px, -1px) rotate(1deg); }
    5% { transform: translate(-1px, 2px) rotate(-1deg); }
    6% { transform: translate(-2px, 1px) rotate(0deg); }
    7% { transform: translate(2px, 1px) rotate(-1deg); }
    8% { transform: translate(-1px, -1px) rotate(1deg); }
    9% { transform: translate(1px, 2px) rotate(0deg); }
    10% { transform: translate(0, 0) rotate(0deg); }
    100% { transform: translate(0, 0) rotate(0deg); }
  }

</style>
